import { render, staticRenderFns } from "./arrange.vue?vue&type=template&id=bd24e002&"
import script from "./arrange.vue?vue&type=script&lang=js&"
export * from "./arrange.vue?vue&type=script&lang=js&"
import style0 from "./arrange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports